// TODO: If possible, remove all stringify for GraphQL

export function encodeString(s: string): string {
  // encode all special chars, u2028 and u2029 are Line separator and Record separator
  return JSON.stringify(s)
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}

export function stringifyLikeJson(v: any, dumpAll = false): string {
  // Returns a string representation of the value, mimicking JSON as far as possible.
  //   In opposite to JSON the attribute names are not quoted. That makes it suitable for GraphQL.
  //   If dumpAll is true, all JSON optimizations are removed but still only known Object types are stringified.
  //   JSON translates some values to null (undefined, unset array entries, functions) and removes attributes with null or undefined values.
  // For graphql:
  //   Filter out attributes with value null or undefined.
  //   Filter out attributes with name __typename
  //

  if (v === undefined) {
    // undefined becomes null in JSON
    return dumpAll ? "undefined" : "null";
  } else if (v === null) {
    return "null";
  } else if (typeof v === "number") {
    // NaN becomes null in JSON, Infinity too.
    if (!dumpAll && !Number.isFinite(v)) {
      return "null";
    }
    return "" + v;
  } else if (typeof v === "boolean") {
    return v ? "true" : "false";
  } else if (typeof v === "function") {
    return !dumpAll ? undefined : "" + v;
  } else if (typeof v === "string") {
    // encode " and <newline> <carriage return>
    return encodeString(v);
  } else if (typeof v === "object") {
    if (v instanceof Array) {
      const s = [];
      // .map leaves out the unset element but JSON includes them -> use for loop
      for (let i = 0; i < v.length; ++i) {
        if (!dumpAll && (v[i] === undefined || typeof v[i] === "function" || typeof v[i] === "symbol")) {
          s.push("null"); // undefined and unset become null in JSON in array context
        } else {
          s.push(stringifyLikeJson(v[i], dumpAll));
        }
      }
      return "[" + s.join() + "]";
    } else if (v instanceof Object) {
      // JSON excludes properties with undefined value and functions
      // graphql will not accept null as value for attributes
      return (
        "{" +
        Object.getOwnPropertyNames(v)
          .filter(
            (key) =>
              dumpAll ||
              (v[key] !== undefined &&
                v[key] !== null &&
                key !== "__typename" &&
                typeof v[key] !== "function" &&
                typeof v[key] !== "symbol"),
          )
          .map((key) => key + ":" + stringifyLikeJson(v[key], dumpAll))
          .join() +
        "}"
      );
    }
    return null;
  }
  return v;
}

export function stringify(v: any): string {
  if (v === undefined) {
    return "undefined";
  } else if (v === null) {
    return "null";
  } else if (typeof v === "boolean") {
    return v ? "true" : "false";
  } else if (typeof v === "string") {
    // encode " and <newline> <carriage return>
    return encodeString(v);
  } else if (typeof v === "object") {
    if (v instanceof Array) {
      const s = [];
      for (let i = 0; i < v.length; ++i) {
        // iterate over unset entries, too.
        s.push(stringify(v[i]));
      }
      return "[" + s.join() + "]";
    } else if (v instanceof Object) {
      return (
        "{" +
        Object.getOwnPropertyNames(v)
          .map((key) => key + ":" + stringify(v[key]))
          .join() +
        "}"
      );
    }
    return null;
  }
  return "" + v;
}

//   see https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
export function replaceErrorsInJsonStringification(_key, value: any): any {
  if (value instanceof Error) {
    const error: any = {};

    Object.getOwnPropertyNames(value).forEach((key) => {
      error[key] = value[key];
    });

    return error;
  }

  return value;
}

export function removeTypename(a: {}): {} {
  if (!a) {
    return a;
  }
  const newObject: {} = {};
  Object.keys(a)
    .filter((key: string) => key !== "__typename")
    .forEach((key: string) => {
      newObject[key] = a[key];
    });
  return newObject;
}
